// @ts-check
// THE CURRENCIES THIS ACADEMY OFFERS, from the server rather than a literal:
// GET /api/academy/currency is Binaa.Platform.Currency's own description of
// Currency:Default and Currency:Offered, so the header's switcher and the
// server's X-Currency check can never disagree about what may be picked.
//
// Anonymous on the server, because the public pages carry the switcher too.
// A failed read leaves the kit's default offer in place — the switcher still
// works, and the server still answers in its own default.

import { configureCurrencies } from '@binaa-almajal/ui-kit/hooks/useCurrency';
import { get } from '../api/http';

/** @type {Promise<void> | null} */
let loading = null;

/** Loads the offer once per page; a failure lets the next call try again. */
export function loadCurrencies() {
    loading ??= get('/currency')
        .then((body) => configureCurrencies(body))
        .catch(() => { loading = null; });
    return loading;
}
